import { dutyTypeList } from "constants/dutyType";
import * as API from "../API/index";
import { authorizedUser } from "components/CommonComponent/CommonFunction";

export const addDutyType = async (bodyData) => {
  try {
    const res = await API.add_duty_type(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const getDutyTypeList = async (dispatch, pageNum, filters) => {
  try {
    const res = await API.duty_type_list(pageNum, filters);
    dispatch({ type: dutyTypeList, payload: res?.data });
  } catch (error) {
    authorizedUser(error.response?.data);
    dispatch({
      type: dutyTypeList,
      payload: error?.response?.data || error,
    });
  }
};

export const getDutyTypeById = async (id) => {
  try {
    const res = await API.get_duty_type_by_ID(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const updateDutyTyperById = async (id, bodyData) => {
  try {
    const res = await API.edit_duty_type(id, bodyData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const deleteDutyTypeById = async (id) => {
  try {
    const res = await API.delete_duty_type_by_ID(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
}